<template>
  <div>
    <v-data-table :loading="loading" :headers="headers" :items="AccountPattyCashs.data" class="elevation-1"
      hide-default-footer>
      <template v-slot:[`item.is_active`]="{ item }">
        <v-icon v-if="item.is_active == 1" color="success">
          mdi-check-circle
        </v-icon>
        <v-icon v-else color="error"> mdi-close-circle </v-icon>
      </template>
      <template v-slot:[`item.membership`]="{ item }">
        <span v-if="item.membership == 1" color="success">Yes</span>
        <span v-else color="success">No</span>
      </template>
      <template v-slot:no-data> No data </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon color="warning" class="mr-2" @click.stop="edit(item)">
          mdi-pencil-box-outline
        </v-icon>
      </template>

      <template v-slot:top>
        <v-row dense class="mx-2">
          <base-column :lg="4" :md="4" :sm="12">
            <v-text-field v-model="search.keyword" append-icon="mdi-magnify" label="Search" outlined dense
              hide-details></v-text-field>
          </base-column>
          <base-column :lg="3" :md="4" :sm="12" v-if="(ROLE == 'Owner')">
            <v-select v-model="search.branch_id" :items="branch" item-text="name" item-value="id" label="Branch" outlined
              dense></v-select>
          </base-column>
          <base-column :lg="3" :md="4" :sm="12">
            <v-btn small color="darkblue" class="white--text" @click.stop="searching">Submit <v-icon
                right>mdi-magnify</v-icon></v-btn>
            <v-btn small color="secondary" class="white--text mx-1" @click.stop="clear">Clear
              <v-icon right>mdi-close-circle-multiple </v-icon>
            </v-btn>
          </base-column>
        </v-row>
      </template>
    </v-data-table>

    <v-pagination v-model="currentPage" :length="lastPage" :total-visible="10" :disabled="disabled"></v-pagination>
  </div>
</template>

<script>
import BaseColumn from "@/components/base/BaseColumn";
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "AccountPattyCashList",
  data() {
    return {
      headers: [
        { text: "Group Patty Cash", value: "group_petty_cash.name" },
        { text: "Name", value: "name" },
        { text: "Description", value: "description" },
        { text: "Action", value: "actions", sortable: false, width: 100 },
      ],
      page: 1,
      disabled: false,
      loading: false,
      status: ["Active", "Inactive"],
      branch: [],
      search: {
        keyword: null,
      },
    };
  },

  created() {
    this.getBranch();
    this.getAccountPattyCash();
  },

  methods: {
    ...mapMutations("account_patty_cash", ["SET_ACCOUNT_PATTY_CASHS", "CLEAR_STATE"]),
    async getAccountPattyCash() {
      this.loading = true;
      this.disabled = true;
      let params = {
        page: this.page,
        branch_id: this.search.branch_id,
        keyword: this.search.keyword,
      };

      await this.$axios
        .get("/transaction/petty-cash-categories", {
          params: params,
          headers: {
            Authorization: this.$store.getters["auth/Token"],
          },
        })
        .then(({ data }) => {
          this.SET_ACCOUNT_PATTY_CASHS(data.resource);
          this.loading = false;
          this.disabled = false;
        });
    },

    async getBranch() {
      await this.$axios
        .get("/master/branches", {
          headers: {
            Authorization: this.$store.getters["auth/Token"],
          },
        })
        .then(({ data }) => {
          this.branch = data.branch.data;
        });
    },
    searching() {
      this.page = 1;
      this.getAccountPattyCash();
    },
    clear() {
      this.page = 1;
      this.search = {
        search: "",
        branch_id: "",
      };
      this.getAccountPattyCash();
    },

    edit(item) {
      this.$router.push("/master/account-petty-cash/edit/" + item.id);
    },
  },
  watch: {
    currentPage(newValue) {
      this.page = newValue;
      this.getAccountPattyCash();
    },
  },
  computed: {
    ...mapGetters("account_patty_cash", {
      AccountPattyCashs: "AccountPattyCashs",
    }),

    ...mapGetters("auth", {
      ROLE: "Role",
    }),

    currentPage: {
      get() {
        return this.AccountPattyCashs.current_page;
      },
      set(val) {
        return this.$store.commit("account_patty_cash/SET_CURRENT_PAGE", val);
      },
    },
    lastPage: {
      get() {
        return this.AccountPattyCashs.last_page;
      },
    },
  },

  destroyed() {
    this.CLEAR_STATE();
  },

  components: {
    BaseColumn,
  },
};
</script>
